module.exports = __webpack_public_path__ + "static/media/trial1-after-10-sek-if-wrong.dd6163c3.mp3";